import { memo, useState } from 'react'
import Section from 'components/common/Section/Section'
import { colors } from 'styles/colors'
import { Box } from '@mui/material'
import { useProductContext } from 'context/ProductContext'


function OCRDetails() {
  // The label text is long and only wanted when the fields read off it are not
  // enough to settle something, so it stays folded away until asked for - the
  // same way the raw product's review card holds it.
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const { product } = useProductContext();

  return (
    <Box mt={3}>
      <Section
        title="OCR Text"
        buttons={[]}
        collapsed={!isVisible}
        onToggle={() => setIsVisible((prev) => !prev)}
        content={isVisible &&
          <Box
            p={1.5}
            sx={{
              backgroundColor: colors.card,
              borderRadius: 1,
              whiteSpace: 'pre-wrap',
              fontSize: 13,
              lineHeight: 1.6,
              color: colors.text,
            }}
          >
            {product.labelText || '—'}
          </Box>
        }
      />
    </Box>
  )
}

export default memo(OCRDetails)
